import {
    Box, Button, Container, FormControl, Grid, InputLabel,
    MenuItem, Select, styled, Typography
  } from '@mui/material';
  import React, { useState } from 'react';
  import cover from '../../../images/Rectangle7.png';
  import { useTranslation } from 'react-i18next';
  import { useSubjectCategoreis } from '../../../hooks/useSubjectCategoreis';
  import { useLevels } from '../../../hooks/useLevels';
  import Cookies from 'js-cookie';
  import { useNavigate } from 'react-router-dom';
  
  const Wrapper = styled(Box)({
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    color: "white",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    height: "80vh"
  });
  
  // ✅ Reusable CustomSelect component
  const CustomSelect = ({ id, label, value, onChange, options, lang }) => (
    <FormControl fullWidth>
      <InputLabel id={`${id}-label`}>{label}</InputLabel>
      <Select
        labelId={`${id}-label`}
        id={id}
        value={value}
        onChange={onChange}
        label={label}
        sx={{ textAlign: "start" }}
        MenuProps={{
          PaperProps: {
            style: {
              maxHeight: 48 * 3 + 8,
              width: 160,
            },
          },
        }}
      >
        {options?.map((item) => (
          <MenuItem key={item.id} value={item.id}>
            {lang === "ar" ? item.titleAR : item.titleEN}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
  
  export default function LandingBanner() {
    const lang = Cookies.get("i18next");
    const { t } = useTranslation();
    const categoriesData = useSubjectCategoreis();
    const levelsData = useLevels();
  
    const [level, setLevel] = useState('');
    const [value, setValue] = useState('');
  
    const navigate = useNavigate();
    const searchNavigate = () => {
      navigate(`/teachers/search?level=${level}&&subjects=${value}`);
    };
  
    return (
      <Wrapper sx={{ backgroundImage: `url(${cover})` }} className="overlay">
        <Container>
          <Typography
            sx={{
              marginBottom: "70px",
              fontSize: { md: "28px", xs: "18px" },
              position: "relative",
              fontWeight: "bold"
            }}
            color="secondary"
          >
            {t('landing_title')}
          </Typography>
          <Grid
            container
            // spacing={2}
            alignItems="center"
            sx={{
              backgroundColor: "white",
              padding: "10px",
              margin:"0px 1px",
              borderRadius: "6px",
              position: "relative",
              zIndex: 3
            }}
          >
            <Grid item xs={12}  lg={4}  my={1} >
              <CustomSelect
                id="categories-select"
                label={t('categories')}
                value={value}
                onChange={(e) => setValue(e.target.value)}
                options={categoriesData?.data?.data || []}
                lang={lang}
              />
            </Grid>
            <Grid item xs={12} my={1}  lg={4} sx={{
                mx:{md:5,xs:0}
            }}>
              <CustomSelect
                id="levels-select"
                label={t('studylevel')}
                value={level}
                onChange={(e) => setLevel(e.target.value)}
                options={levelsData?.data?.data || []}
                lang={lang}
              />
            </Grid>
            <Grid item xs={12} md={12} lg={2}>
              <Button variant="contained" fullWidth onClick={searchNavigate}>
                {t('search')}
              </Button>
            </Grid>
          </Grid>
        </Container>
      </Wrapper>
    );
  }
  